import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";

import { environment } from "../../environments/environment";

import { Respuesta } from "../_models/shared/_index";
import {
    ErrorValidacion,
    CargaArchivo,
    CombinacionAtributos,
} from "../_models/carga-patentamientos/_index";
import { TmmvNodo } from "../_models/shared/_index";
import { Ofmm } from "../_models/shared/ofmm";
import { ErrorService } from "./error.service";
import { Patentamiento } from "../_models/shared/patentamiento";

@Injectable()
export class CargaPatentamientosService {
    private uploadFileUrl =
        environment.rest + "/CargaPatentamientos/UploadFile";
    private processFileUrl =
        environment.rest + "/CargaPatentamientos/ProcessFile";
    private getInfoValidadaCargaUrl =
        environment.rest + "/CargaPatentamientos/GetInfoValidadaCarga";
    private corregirDatosCargaUrl =
        environment.rest + "/CargaPatentamientos/CorregirDatosCarga";
    private agregarCombinacionAtributosUrl =
        environment.rest + "/CargaPatentamientos/AgregarCombinacionAtributo";
    private getCargasPatsInternacionalUrl =
        environment.rest + "/CargaPatentamientos/GetCargasPatsInternacional";
    private getCombinacionesAtributosUrl =
        environment.rest + "/CargaPatentamientos/GetCombinacionesAtributos";
    private getCombinacionesAtributosPorVersionUrl =
        environment.rest +
        "/CargaPatentamientos/GetCombinacionesAtributosPorVersion";
    private getCombinacionesAtributosByIdCargaUrl =
        environment.rest +
        "/CargaPatentamientos/GetCombinacionesAtributosByIdCarga";
    private getCombinacionesAtributosByIdCargaLengthUrl =
        environment.rest +
        "/CargaPatentamientos/GetCombinacionesAtributosByIdCargaLength";
    private deleteCombinacionAtributoPorVersionUrl =
        environment.rest +
        "/CargaPatentamientos/DeleteCombinacionesAtributosPorVersion";
    private getClientesPatsUrl =
        environment.rest + "/CargaPatentamientos/GetClientesPats";
    private delCargaInternacionalUrl =
        environment.rest + "/CargaPatentamientos/DelCargaInternacional";
    private setfechasCargaUrl =
        environment.rest + "/CargaPatentamientos/SetfechasCarga";
    private getUltimasFechasDeCargaUrl =
        environment.rest + "/CargaPatentamientos/GetUltimasFechasDeCarga";
    private addPatsInternacionalByCargaUrl =
        environment.rest + "/CargaPatentamientos/addPatsInternacionalByCarga";
    private getTmmvNodosUrl =
        environment.rest + "/CargaPatentamientos/GetTmmvNodos";
    private getHijosByTmmvNodoModelUrl =
        environment.rest + "/CargaPatentamientos/GetHijosByTmmvNodoModel";
    private setVersionPorCombinacionesAtributosUrl =
        environment.rest +
        "/CargaPatentamientos/SetVersionPorCombinacionesAtributos";
    private marcarComoErroneosLosSeleccionadosUrl =
        environment.rest +
        "/CargaPatentamientos/MarcarComoErroneosLosSeleccionados";
    private reprocesarErroneosUrl =
        environment.rest + "/CargaPatentamientos/ReprocesarErroneos";
    private deleteCombinacionesAtributosUrl =
        environment.rest + "/CargaPatentamientos/DeleteCombinacionesAtributos";
    private eliminarVersionPorCombinacionAtributosUrl =
        environment.rest +
        "/CargaPatentamientos/EliminarVersionPorCombinacionAtributos";
    private getPatsByMotorAndClienteUrl =
        environment.rest + "/CargaPatentamientos/GetPatsByMotorAndCliente";
    private getPatsByChasisAndClienteUrl =
        environment.rest + "/CargaPatentamientos/GetPatsByChasisAndCliente";
    private getPatsByDominioAndClienteUrl =
        environment.rest + "/CargaPatentamientos/GetPatsByDominioAndCliente";
    private getPatsByOfmmAndClienteUrl =
        environment.rest + "/CargaPatentamientos/GetPatsByOfmmAndCliente";
    private getPatsByModeloAndClienteUrl =
        environment.rest + "/CargaPatentamientos/GetPatsByModeloAndCliente";
    private getPatsByVersionAndClienteUrl =
        environment.rest + "/CargaPatentamientos/GetPatsByVersionAndCliente";
    private personalizarPatsManualUrl =
        environment.rest + "/CargaPatentamientos/PersonalizarPatsManual";
    private agregarCombinacionDivisionPoliticaUrl =
        environment.rest +
        "/CargaPatentamientos/AgregarCombinacionesDivisionPolitica";

    private options = {
        headers: new HttpHeaders({ "Content-Type": "application/json" }),
        withCredentials: true,
    };

    constructor(private http: HttpClient, private errorService: ErrorService) {}

    uploadFile(formData): Observable<Respuesta> {
        var options = { withCredentials: true };
        return this.http
            .post<Respuesta>(this.uploadFileUrl, formData, options)
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> uploadFile`
                    )
                )
            );
    }

    processFile(carga: CargaArchivo): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.processFileUrl,
                { cargaPatModel: carga },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> processFile`
                    )
                )
            );
    }

    getInfoValidadaCarga(cargaArchivo: CargaArchivo): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getInfoValidadaCargaUrl,
                { cargaArchivo: cargaArchivo },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> getInfoValidadaCarga`
                    )
                )
            );
    }

    corregirDatosCarga(
        error: ErrorValidacion,
        cargaPatModel: CargaArchivo
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.corregirDatosCargaUrl,
                { cargaPatModel, error },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> corregirDatosCarga`
                    )
                )
            );
    }

    agregarCombinacionAtributo(
        error: ErrorValidacion,
        carga: CargaArchivo
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.agregarCombinacionAtributosUrl,
                { error, carga },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> agregarCombinacionAtributo`
                    )
                )
            );
    }

    // Obtengo las combinaciones atributos
    getCombinacionesAtributos(): Observable<Respuesta> {
        return this.http
            .get<Respuesta>(this.getCombinacionesAtributosUrl, this.options)
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `GET -> getCombinacionesAtributos`
                    )
                )
            );
    }

    public getCombinacionesAtributosPorVersion(
        version: TmmvNodo
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getCombinacionesAtributosPorVersionUrl,
                { version },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> getCombinacionesAtributosPorVersion`
                    )
                )
            );
    }

    public getCombinacionesAtributosByIdCarga(
        idCarga: number
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getCombinacionesAtributosByIdCargaUrl,
                { idCarga },
                this.options
            )
            .pipe(
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> getCombinacionesAtributosByIdCarga`
                    )
                )
            );
    }

    public getCombinacionesAtributosByIdCargaLength(
        idCarga: number
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getCombinacionesAtributosByIdCargaLengthUrl,
                { idCarga },
                this.options
            )
            .pipe(
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> getCombinacionesAtributosByIdCargaLength`
                    )
                )
            );
    }

    public deleteCombinacionesAtributosPorVersion(
        cas: CombinacionAtributos[],
        version: TmmvNodo
    ) {
        return this.http
            .post<Respuesta>(
                this.deleteCombinacionAtributoPorVersionUrl,
                { cas: cas, version: version },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> deleteCombinacionesAtributosPorVersion`
                    )
                )
            );
    }

    public deleteCombinacionesAtributos(
        idCarga: number,
        cas: Array<CombinacionAtributos>
    ) {
        return this.http
            .post<Respuesta>(
                this.deleteCombinacionesAtributosUrl,
                { idCarga: idCarga, cas: cas },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> deleteCombinacionesAtributos`
                    )
                )
            );
    }

    public eliminarVersionPorCombinacionAtributos(
        idVersion: number,
        idsCas: number[]
    ) {
        return this.http
            .post<Respuesta>(
                this.eliminarVersionPorCombinacionAtributosUrl,
                { idsCas: idsCas, idVersion: idVersion },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> eliminarVersionPorCombinacionAtributos`
                    )
                )
            );
    }

    getCargasPatsInternacional(): Observable<Respuesta> {
        return this.http
            .get<Respuesta>(this.getCargasPatsInternacionalUrl, this.options)
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `GET -> getCargasPatsInternacional`
                    )
                )
            );
    }

    getUltimasFechasDeCarga(): Observable<Respuesta> {
        return this.http
            .get<Respuesta>(this.getUltimasFechasDeCargaUrl, this.options)
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `GET -> getUltimasFechasDeCarga`
                    )
                )
            );
    }

    delCargaInternacional(idCarga: number, eliminarCombinaciones: boolean) {
        return this.http
            .post<Respuesta>(
                this.delCargaInternacionalUrl,
                {
                    idCarga: idCarga,
                    eliminarCombinaciones: eliminarCombinaciones,
                },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> delCargaInternacional`
                    )
                )
            );
    }

    getClientesPats() {
        return this.http
            .get<Respuesta>(this.getClientesPatsUrl, this.options)
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `GET -> getClientesPats`
                    )
                )
            );
    }

    setFechasCarga(clientes: Array<any>) {
        return this.http
            .post<Respuesta>(this.setfechasCargaUrl, { clientes }, this.options)
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> setFechasCarga`
                    )
                )
            );
    }

    // Obtengo los TmmvNodos
    public getTmmvNodos(idNodoRaiz: number): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(this.getTmmvNodosUrl, { idNodoRaiz }, this.options)
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> getTmmvNodos`
                    )
                )
            );
    }

    public getHijosByTmmvNodoModel(raiz: TmmvNodo): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getHijosByTmmvNodoModelUrl,
                { raiz },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> getHijosByTmmvNodoModel`
                    )
                )
            );
    }

    public setVersionPorCombinacionesAtributos(
        nodo: TmmvNodo,
        combinacionesAtributos: CombinacionAtributos[]
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.setVersionPorCombinacionesAtributosUrl,
                { nodo, combinacionesAtributos },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> setVersionPorCombinacionesAtributos`
                    )
                )
            );
    }

    public getPatsByMotorAndCliente(
        motores: string,
        idCliente: number
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getPatsByMotorAndClienteUrl,
                { motores, idCliente },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `get getPatsByMotorAndCliente`
                    )
                )
            );
    }

    public getPatsByChasisAndCliente(
        chasis: string,
        idCliente: number
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getPatsByChasisAndClienteUrl,
                { chasis, idCliente },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `get getPatsByChasisAndCliente`
                    )
                )
            );
    }

    public getPatsByDominioAndCliente(
        dominios: string,
        idCliente: number
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getPatsByDominioAndClienteUrl,
                { dominios, idCliente },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `get getPatsByDominioAndCliente`
                    )
                )
            );
    }

    public getPatsByOfmmAndCliente(
        ofmm: Ofmm,
        idCliente: number,
        fechaDesde: Date,
        fechaHasta: Date
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getPatsByOfmmAndClienteUrl,
                { ofmm, idCliente, fechaDesde, fechaHasta },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `get getPatsByOfmmAndCliente`
                    )
                )
            );
    }

    public getPatsByModeloAndCliente(
        idModelo: number,
        idCliente: number,
        fechaDesde: Date,
        fechaHasta: Date
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getPatsByModeloAndClienteUrl,
                { idModelo, idCliente, fechaDesde, fechaHasta },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `get getPatsByModeloAndCliente`
                    )
                )
            );
    }

    public personalizarPatsManual(
        pats: Array<Patentamiento>,
        idCliente: number
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.personalizarPatsManualUrl,
                { pats, idCliente },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `get personalizarPatsManual`
                    )
                )
            );
    }

    public getPatsByVersionAndCliente(
        idVersion: number,
        idCliente: number,
        fechaDesde: Date,
        fechaHasta: Date,
        esVersionParcial: boolean
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.getPatsByVersionAndClienteUrl,
                {
                    idVersion,
                    idCliente,
                    fechaDesde,
                    fechaHasta,
                    esVersionParcial,
                },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `get getPatsByVersionAndCliente`
                    )
                )
            );
    }

    addPatsInternacionalByCarga(idCarga: number) {
        return this.http
            .post<Respuesta>(
                this.addPatsInternacionalByCargaUrl,
                { idCarga: idCarga },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> addPatsInternacionalByCarga`
                    )
                )
            );
    }

    public marcarComoErroneosLosSeleccionados(
        cargaPatModel: CargaArchivo,
        error: ErrorValidacion,
        idEstado: number
    ) {
        return this.http
            .post<Respuesta>(
                this.marcarComoErroneosLosSeleccionadosUrl,
                { cargaPatModel, error, idEstado },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> marcarComoErroneosLosSeleccionados`
                    )
                )
            );
    }

    public reprocesarErroneos(
        cargaPatModel: CargaArchivo,
        error: ErrorValidacion,
        idEstado: number
    ) {
        return this.http
            .post<Respuesta>(
                this.reprocesarErroneosUrl,
                { cargaPatModel, error, idEstado },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> reprocesarErroneos`
                    )
                )
            );
    }

    agregarCombinacionesDivisionPolitica(
        error: ErrorValidacion,
        carga: CargaArchivo
    ): Observable<Respuesta> {
        return this.http
            .post<Respuesta>(
                this.agregarCombinacionDivisionPoliticaUrl,
                { error, carga },
                this.options
            )
            .pipe(
                tap((res) => {
                    this.errorService.CheckResponse(res);
                }),
                catchError(
                    this.errorService.handleError<Respuesta>(
                        `POST -> agregarCombinacionesDivisionPolitica`
                    )
                )
            );
    }

    private handleError<T>(operation = "operation", result?: T) {
        return (error: any): Observable<Respuesta> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            console.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(new Respuesta());
        };
    }
}
